import { render, staticRenderFns } from "./TerrainControlledAccess.vue?vue&type=template&id=62637fc4&scoped=true"
import script from "./TerrainControlledAccess.vue?vue&type=script&lang=js"
export * from "./TerrainControlledAccess.vue?vue&type=script&lang=js"
import style0 from "./TerrainControlledAccess.vue?vue&type=style&index=0&id=62637fc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62637fc4",
  null
  
)

export default component.exports